import type { ComponentPropsWithoutRef } from 'react';
import { DropdownMenuItem } from '@/components/ui/dropdown-menu';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

type DropdownMenuItemWithTooltipProps = ComponentPropsWithoutRef<typeof DropdownMenuItem> & {
  disabledReason?: string | null;
};

export function DropdownMenuItemWithTooltip({
  disabled,
  disabledReason,
  className,
  onClick,
  onSelect,
  ...props
}: DropdownMenuItemWithTooltipProps) {
  const item = (
    <DropdownMenuItem
      disabled={disabled}
      onClick={disabled ? undefined : onClick}
      onSelect={disabled
        ? (event) => {
            event.preventDefault();
            event.stopPropagation();
          }
        : onSelect}
      className={cn(
        className,
        disabled && disabledReason && 'data-disabled:pointer-events-auto data-disabled:cursor-help',
      )}
      {...props}
    />
  );

  if (!disabled || !disabledReason) {
    return item;
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>{item}</TooltipTrigger>
        <TooltipContent side="left" className="max-w-[260px] text-xs">
          {disabledReason}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
